let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e5Kbr")).then(() => parcelRequire('l9pzx'));